import * as TYPES from './action-types';

export const setProjectRole = data => ({
  type: TYPES.SET_PROJECT_ROLE,
  data,
});